<template>
  <div id="tree-content">
    <div class="block-middle">
      <div class="caption">
        <span>Estratégico</span>
        <span>Tático</span>
        <span>Operacional</span>
        <span><div class="line-solid" />Conexões Naturais</span>
        <span><div class="line-dashed" />Conexões Possíveis</span>
      </div>
    </div>
  </div>
</template>

<script>
  // import EventSystem from '../utils/EventSystem';

  export default {
    props: {
    },
    data() {
      return {
      };
    },
    created() {
    },
    computed: {
    },
    methods: {
    },
  };

</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/tree-content.vue